var _rect, _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _rect2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 311,
    viewBox: "0 0 375 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -36,
    width: 375,
    height: 328,
    fill: "#FFF4EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2881 236.944L124.166 151.143C126.659 147.743 131.239 147.861 133.595 151.387L199.246 249.62L61.2881 236.944Z",
    fill: "#F9A061"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_52_530",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 148,
    width: 139,
    height: 102
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2881 236.944L124.166 151.143C126.659 147.743 131.239 147.861 133.595 151.387L199.246 249.62L61.2881 236.944Z",
    fill: "#F9A061"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_52_530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.739 188.99C103.744 188.99 99.6945 184.323 99.6945 178.564V141.147H117.781V178.564C117.784 184.321 113.734 188.99 108.739 188.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.669 195.345C121.674 195.345 117.624 190.678 117.624 184.918V147.502H135.711V184.918C135.713 190.678 131.664 195.345 126.669 195.345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.743 182.656C139.747 182.656 135.698 177.989 135.698 172.23V134.813H153.785V172.23C153.787 177.989 149.738 182.656 144.743 182.656Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-25 245.078L37.8781 170.663C40.3706 167.714 44.9506 167.817 47.3072 170.876L112.96 256.072L-25 245.078Z",
    fill: "#F9A061"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_52_530",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -25,
    y: 168,
    width: 138,
    height: 89
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-25 245.078L37.8781 170.663C40.3706 167.714 44.9506 167.816 47.3072 170.876L112.96 256.071L-25 245.078Z",
    fill: "#F9A061"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_52_530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2227 198.632C16.8939 198.632 12.573 194.311 12.573 188.983V154.361H31.8698V188.985C31.8724 194.314 27.5514 198.632 22.2227 198.632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3528 196.717C36.0241 196.717 31.7031 192.396 31.7031 187.067V152.446H50.9999V187.07C51.0025 192.396 46.6815 196.717 41.3528 196.717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6368 202.304C55.3081 202.304 50.9871 197.984 50.9871 192.655V158.033H70.2839V192.657C70.2865 197.984 65.9655 202.304 60.6368 202.304Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.415 264.111C204.415 264.111 242.637 219.84 323.55 219.84C347.355 219.84 366.688 223.512 382.125 228.692V262.664L204.415 264.111Z",
    fill: "#F9A061"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2886 239.341C92.2886 239.341 121.576 196.94 202.487 196.94C283.398 196.94 321.622 241.213 321.622 241.213L92.2886 239.341Z",
    fill: "#F9A061"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M358.185 181.636C358.185 192.642 349.263 201.563 338.257 201.563C327.253 201.563 318.329 192.642 318.329 181.636C318.329 170.63 327.251 161.708 338.257 161.708C349.263 161.711 358.185 170.632 358.185 181.636Z",
    fill: "#F9A061"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 239,
    width: 375,
    height: 72,
    fill: "#E87722"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2465 158.29H32.7135V145.907C32.7135 139.685 37.7576 134.639 43.9813 134.639C50.2024 134.639 55.2491 139.683 55.2491 145.907V158.29H55.2465Z",
    fill: "#F9E3D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4301 158.29H27.3616C24.8947 158.29 22.8971 156.292 22.8971 153.825C22.8971 151.358 24.8947 149.361 27.3616 149.361H45.4301V158.29Z",
    fill: "#F9E3D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3063 158.29H48.9998V141.834H63.3063C67.8504 141.834 71.5353 145.517 71.5353 150.061C71.5328 154.607 67.8478 158.29 63.3063 158.29Z",
    fill: "#F9E3D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M218.391 164.96H197.715C193.442 164.96 189.978 161.495 189.978 157.223C189.978 152.951 193.442 149.486 197.715 149.486H218.391V164.96Z",
    fill: "#F9E3D3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M230.313 164.96H201.902V147.189C201.902 139.342 208.262 132.982 216.109 132.982C223.956 132.982 230.315 139.344 230.315 147.189V164.96H230.313Z",
    fill: "#F9E3D3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M250.61 164.96H222.197V143.822H237.572C244.771 143.822 250.61 149.658 250.61 156.856V164.96Z",
    fill: "#F9E3D3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M257.272 164.96H233.357V155.964H257.272C259.754 155.964 261.77 157.977 261.77 160.462C261.77 162.947 259.757 164.96 257.272 164.96Z",
    fill: "#F9E3D3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8195 190.378H69.8249C67.099 190.378 64.8885 188.167 64.8885 185.441C64.8885 182.713 67.099 180.505 69.8249 180.505H92.8195C95.548 180.505 97.7559 182.715 97.7559 185.441C97.7584 188.167 95.548 190.378 92.8195 190.378Z",
    fill: "#F9E3D3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1142 189.249H74.6202V178.528C74.6202 173.696 78.536 169.781 83.3672 169.781C88.1985 169.781 92.1142 173.696 92.1142 178.528V189.249Z",
    fill: "#F9E3D3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M334.492 150.766H357.487C360.213 150.766 362.423 148.556 362.423 145.83C362.423 143.101 360.213 140.893 357.487 140.893H334.492C331.764 140.893 329.556 143.104 329.556 145.83C329.556 148.556 331.764 150.766 334.492 150.766Z",
    fill: "#F9E3D3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M335.198 149.638H352.692V138.916C352.692 134.085 348.776 130.169 343.945 130.169C339.113 130.169 335.198 134.085 335.198 138.916V149.638Z",
    fill: "#F9E3D3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M212.801 252.879H208.113C207.69 252.879 207.344 253.222 207.344 253.648C207.344 254.074 207.687 254.415 208.113 254.415H212.801V252.879Z",
    fill: "#183028"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M213.803 223.166H211.583V254.417H213.803V223.166Z",
    fill: "#183028"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M212.708 179.056V226.915C220.253 226.904 226.369 220.788 226.369 213.241V192.732C226.369 185.185 220.253 179.066 212.708 179.056Z",
    fill: "#F2BB90"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M212.693 179.056C205.141 179.056 199.02 185.18 199.02 192.729V213.239C199.02 220.794 205.144 226.912 212.693 226.912H212.708V179.056H212.693Z",
    fill: "#E77724"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M226.371 206.118C226.371 206.118 225.748 211.59 221.989 215.352C218.229 219.111 212.755 219.734 212.755 219.734C212.755 219.734 213.378 214.262 217.137 210.5C220.896 206.741 226.371 206.118 226.371 206.118Z",
    fill: "#F9E3D3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M199.051 206.064C199.051 206.064 199.674 211.536 203.433 215.298C207.193 219.057 212.667 219.681 212.667 219.681C212.667 219.681 212.044 214.208 208.285 210.446C204.526 206.684 199.051 206.064 199.051 206.064Z",
    fill: "#F2BB90"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M226.371 191.498C226.371 191.498 225.748 196.971 221.989 200.733C218.229 204.492 212.755 205.115 212.755 205.115C212.755 205.115 213.378 199.643 217.137 195.881C220.896 192.119 226.371 191.498 226.371 191.498Z",
    fill: "#E77724"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M199.051 191.444C199.051 191.444 199.674 196.917 203.433 200.679C207.193 204.438 212.667 205.061 212.667 205.061C212.667 205.061 212.044 199.589 208.285 195.827C204.526 192.065 199.051 191.444 199.051 191.444Z",
    fill: "#F9E3D3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M220.961 181.915C220.961 181.915 220.584 185.221 218.314 187.49C216.042 189.762 212.737 190.137 212.737 190.137C212.737 190.137 213.114 186.831 215.383 184.559C217.655 182.292 220.961 181.915 220.961 181.915Z",
    fill: "#F9E3D3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M204.461 181.882C204.461 181.882 204.838 185.187 207.108 187.457C209.38 189.729 212.685 190.103 212.685 190.103C212.685 190.103 212.308 186.798 210.039 184.526C207.767 182.259 204.461 181.882 204.461 181.882Z",
    fill: "#F2BB90"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M269.196 256.864H264.098C263.637 256.864 263.262 257.239 263.262 257.7C263.262 258.162 263.637 258.534 264.098 258.534H269.196V256.864Z",
    fill: "#183028"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M270.286 224.551H267.87V258.539H270.286V224.551Z",
    fill: "#183028"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M269.094 176.582V228.631C277.3 228.621 283.949 221.969 283.949 213.76V191.453C283.949 183.244 277.3 176.592 269.094 176.582Z",
    fill: "#F2BB90"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M269.078 176.582C260.865 176.582 254.207 183.242 254.207 191.453V213.76C254.207 221.974 260.865 228.631 269.078 228.631H269.094V176.582H269.078Z",
    fill: "#E77724"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M283.951 206.011C283.951 206.011 283.274 211.962 279.187 216.053C275.097 220.143 269.145 220.817 269.145 220.817C269.145 220.817 269.822 214.865 273.909 210.775C278 206.688 283.951 206.011 283.951 206.011Z",
    fill: "#F9E3D3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M254.241 205.952C254.241 205.952 254.918 211.904 259.005 215.994C263.096 220.084 269.047 220.758 269.047 220.758C269.047 220.758 268.37 214.806 264.283 210.716C260.193 206.629 254.241 205.952 254.241 205.952Z",
    fill: "#F2BB90"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M283.951 190.112C283.951 190.112 283.274 196.064 279.187 200.154C275.097 204.244 269.145 204.918 269.145 204.918C269.145 204.918 269.822 198.966 273.909 194.876C278 190.789 283.951 190.112 283.951 190.112Z",
    fill: "#E77724"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M254.241 190.053C254.241 190.053 254.918 196.004 259.005 200.095C263.096 204.185 269.047 204.859 269.047 204.859C269.047 204.859 268.37 198.907 264.283 194.817C260.193 190.73 254.241 190.053 254.241 190.053Z",
    fill: "#F9E3D3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M278.069 179.69C278.069 179.69 277.661 183.285 275.192 185.755C272.722 188.224 269.127 188.635 269.127 188.635C269.127 188.635 269.535 185.039 272.007 182.57C274.474 180.1 278.069 179.69 278.069 179.69Z",
    fill: "#F9E3D3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M260.123 179.654C260.123 179.654 260.531 183.249 263.001 185.719C265.47 188.188 269.065 188.599 269.065 188.599C269.065 188.599 268.658 185.003 266.186 182.534C263.719 180.064 260.123 179.654 260.123 179.654Z",
    fill: "#F2BB90"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M305.925 253.117H300.615C300.133 253.117 299.743 253.506 299.743 253.986C299.743 254.466 300.133 254.858 300.615 254.858H305.925V253.117Z",
    fill: "#183028"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M307.061 232.299H304.546V254.86H307.061V232.299Z",
    fill: "#183028"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M305.997 205.709L305.923 235.979C314.724 235.979 321.86 229.204 321.86 220.844C321.86 212.508 314.765 205.748 305.997 205.709Z",
    fill: "#F9E3D3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M305.925 205.707C297.125 205.707 289.988 212.482 289.988 220.842C289.988 229.202 297.122 235.977 305.925 235.977L306 205.707H305.925Z",
    fill: "#EDB58B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M314.003 207.835C314.003 207.835 313.637 211.061 311.421 213.277C309.203 215.495 305.977 215.862 305.977 215.862C305.977 215.862 306.343 212.636 308.562 210.418C310.777 208.202 314.003 207.835 314.003 207.835Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M314.003 217.88C314.003 217.88 313.637 221.106 311.421 223.321C309.203 225.54 305.977 225.906 305.977 225.906C305.977 225.906 306.343 222.68 308.562 220.462C310.777 218.247 314.003 217.88 314.003 217.88Z",
    fill: "#EDB58B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M314.003 227.924C314.003 227.924 313.637 231.15 311.421 233.366C309.203 235.584 305.977 235.951 305.977 235.951C305.977 235.951 306.343 232.725 308.562 230.507C310.777 228.291 314.003 227.924 314.003 227.924Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M297.95 207.802C297.95 207.802 298.317 211.028 300.533 213.243C302.751 215.462 305.977 215.828 305.977 215.828C305.977 215.828 305.61 212.602 303.392 210.384C301.176 208.169 297.95 207.802 297.95 207.802Z",
    fill: "#F9E3D3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M297.902 217.849C297.902 217.849 298.268 221.075 300.484 223.291C302.702 225.509 305.928 225.876 305.928 225.876C305.843 225.124 306.31 223.398 303.343 220.431C301.128 218.216 297.902 217.849 297.902 217.849Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M297.799 227.894C297.799 227.894 298.166 231.12 300.381 233.335C302.599 235.553 305.825 235.92 305.825 235.92C305.825 235.92 305.459 232.694 303.241 230.476C301.025 228.26 297.799 227.894 297.799 227.894Z",
    fill: "#F9E3D3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1331 254.391H19.2788C18.8403 254.391 18.4838 254.748 18.4838 255.186C18.4838 255.625 18.8403 255.981 19.2788 255.981H24.1331V254.391Z",
    fill: "#183028"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1717 212.997H22.8715V255.984H25.1717V212.997Z",
    fill: "#183028"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0305 185.03L23.9562 215.3C32.7571 215.3 39.8937 208.525 39.8937 200.165C39.8937 191.826 32.7981 185.066 24.0305 185.03Z",
    fill: "#F9E3D3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9587 185.028C15.1579 185.028 8.02124 191.803 8.02124 200.163C8.02124 208.522 15.1553 215.298 23.9587 215.298L24.0331 185.028H23.9587Z",
    fill: "#EDB58B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0365 187.154C32.0365 187.154 31.6698 190.38 29.4541 192.595C27.236 194.813 24.01 195.18 24.01 195.18C24.01 195.18 24.3767 191.954 26.5949 189.736C28.8105 187.52 32.0365 187.154 32.0365 187.154Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0365 197.201C32.0365 197.201 31.6698 200.427 29.4541 202.642C27.236 204.861 24.01 205.227 24.01 205.227C24.01 205.227 24.3767 202.001 26.5949 199.783C28.8105 197.568 32.0365 197.201 32.0365 197.201Z",
    fill: "#EDB58B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0365 207.245C32.0365 207.245 31.6698 210.471 29.4541 212.687C27.236 214.905 24.01 215.272 24.01 215.272C24.01 215.272 24.3767 212.046 26.5949 209.828C28.8105 207.612 32.0365 207.245 32.0365 207.245Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9811 187.123C15.9811 187.123 16.3478 190.349 18.5634 192.564C20.7816 194.783 24.0075 195.149 24.0075 195.149C24.0075 195.149 23.6408 191.923 21.4226 189.705C19.2096 187.49 15.9811 187.123 15.9811 187.123Z",
    fill: "#F9E3D3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9349 197.168C15.9349 197.168 16.3016 200.393 18.5172 202.609C20.7354 204.827 23.9613 205.194 23.9613 205.194C23.8767 204.443 24.3434 202.717 21.3764 199.75C19.1608 197.534 15.9349 197.168 15.9349 197.168Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8323 207.212C15.8323 207.212 16.199 210.438 18.4146 212.654C20.6328 214.872 23.8588 215.239 23.8588 215.239C23.8588 215.239 23.4921 212.013 21.2739 209.794C19.0583 207.579 15.8323 207.212 15.8323 207.212Z",
    fill: "#F9E3D3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M190.632 258.546H185.734C185.293 258.546 184.931 258.905 184.931 259.349C184.931 259.79 185.29 260.151 185.734 260.151H190.632V258.546Z",
    fill: "#183028"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M191.678 242.221H189.357V260.157H191.678V242.221Z",
    fill: "#183028"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M190.527 213.995L190.452 244.542C199.335 244.542 206.536 237.703 206.536 229.269C206.539 220.853 199.376 214.031 190.527 213.995Z",
    fill: "#B8E1D6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M190.455 213.993C181.572 213.993 174.374 220.832 174.374 229.266C174.374 237.703 181.575 244.54 190.455 244.54L190.529 213.993H190.455Z",
    fill: "#74C8AF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M198.607 216.139C198.607 216.139 198.238 219.396 195.999 221.632C193.763 223.868 190.506 224.24 190.506 224.24C190.506 224.24 190.878 220.983 193.114 218.747C195.353 216.508 198.607 216.139 198.607 216.139Z",
    fill: "#E4F3EF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M198.607 226.276C198.607 226.276 198.238 229.533 195.999 231.769C193.763 234.005 190.506 234.377 190.506 234.377C190.506 234.377 190.878 231.12 193.114 228.884C195.353 226.645 198.607 226.276 198.607 226.276Z",
    fill: "#74C8AF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M198.607 236.413C198.607 236.413 198.238 239.67 195.999 241.906C193.763 244.142 190.506 244.514 190.506 244.514C190.506 244.514 190.878 241.257 193.114 239.021C195.353 236.785 198.607 236.413 198.607 236.413Z",
    fill: "#E4F3EF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M182.405 216.106C182.405 216.106 182.775 219.363 185.013 221.599C187.249 223.835 190.506 224.207 190.506 224.207C190.506 224.207 190.134 220.95 187.898 218.714C185.662 216.478 182.405 216.106 182.405 216.106Z",
    fill: "#B8E1D6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M182.357 226.245C182.357 226.245 182.726 229.502 184.965 231.738C187.201 233.974 190.457 234.346 190.457 234.346C190.37 233.59 190.842 231.846 187.849 228.853C185.613 226.615 182.357 226.245 182.357 226.245Z",
    fill: "#E4F3EF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M182.254 236.382C182.254 236.382 182.623 239.639 184.862 241.875C187.098 244.111 190.355 244.481 190.355 244.481C190.355 244.481 189.983 241.224 187.747 238.99C185.511 236.752 182.254 236.382 182.254 236.382Z",
    fill: "#B8E1D6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M364.359 246.345H365.052V239.429L364.359 239.239V246.345Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M337.195 244.906H331.997C331.597 244.906 331.272 245.232 331.272 245.632C331.272 246.035 331.597 246.358 331.997 246.358H337.195V244.906Z",
    fill: "#183028"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M362.416 246.36H337.195V224.75C337.195 223.135 338.503 221.827 340.121 221.827H359.49C361.105 221.827 362.416 223.135 362.416 224.75V246.36Z",
    fill: "#FED241"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M341.983 228.743H340.888C340.614 228.743 340.39 228.52 340.39 228.246V225.948C340.39 225.673 340.614 225.45 340.888 225.45H341.983C342.257 225.45 342.48 225.673 342.48 225.948V228.246C342.48 228.52 342.257 228.743 341.983 228.743Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M347.33 228.743H346.235C345.96 228.743 345.737 228.52 345.737 228.246V225.948C345.737 225.673 345.96 225.45 346.235 225.45H347.33C347.604 225.45 347.827 225.673 347.827 225.948V228.246C347.827 228.52 347.604 228.743 347.33 228.743Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M352.679 228.743H351.584C351.309 228.743 351.086 228.52 351.086 228.246V225.948C351.086 225.673 351.309 225.45 351.584 225.45H352.679C352.953 225.45 353.176 225.673 353.176 225.948V228.246C353.176 228.52 352.953 228.743 352.679 228.743Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M358.026 228.743H356.931C356.656 228.743 356.433 228.52 356.433 228.246V225.948C356.433 225.673 356.656 225.45 356.931 225.45H358.026C358.3 225.45 358.523 225.673 358.523 225.948V228.246C358.523 228.52 358.302 228.743 358.026 228.743Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M342.48 231.936H340.39V235.228H342.48V231.936Z",
    fill: "#C75528"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M347.827 231.936H345.737V235.228H347.827V231.936Z",
    fill: "#EAB520"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M353.176 231.936H351.086V235.228H353.176V231.936Z",
    fill: "#C75528"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M358.523 231.936H356.433V235.228H358.523V231.936Z",
    fill: "#C75528"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M347.181 246.324H341.18V239.234C341.18 238.552 341.732 237.998 342.416 237.998H345.947C346.63 237.998 347.183 238.549 347.183 239.234V246.324H347.181Z",
    fill: "#FED241"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M358.233 246.324H352.233V239.234C352.233 238.552 352.784 237.998 353.466 237.998H356.997C357.679 237.998 358.233 238.549 358.233 239.234V246.324Z",
    fill: "#FED241"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M365.47 246.347H363.967C363.967 246.07 364.19 245.847 364.467 245.847H364.97C365.244 245.847 365.47 246.07 365.47 246.347Z",
    fill: "#8A9793"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M334.523 239.429V246.347H335.216V239.239L334.523 239.429Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M334.108 246.347H335.61C335.61 246.07 335.387 245.847 335.11 245.847H334.608C334.331 245.847 334.108 246.07 334.108 246.347Z",
    fill: "#8A9793"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M362.413 231.802V231.816L362.418 231.802H362.413Z",
    fill: "#FBB41B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M337.154 242.519H337.195V240.99L337.154 242.519Z",
    fill: "#E76224"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M362.416 231.802L358.526 232.746V235.228H356.436V233.251L353.176 234.041V235.226H351.086V234.546L337.275 237.895L337.195 240.988V242.516H341.18V239.231C341.18 238.549 341.732 237.995 342.416 237.995H345.947C346.63 237.995 347.181 238.547 347.181 239.231V242.516H352.233V239.231C352.233 238.549 352.784 237.995 353.469 237.995H357C357.682 237.995 358.233 238.547 358.233 239.231V242.516H360.859L362.413 231.815V231.802H362.416Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M351.086 234.549V235.228H353.176V234.041L351.086 234.549Z",
    fill: "#C74827"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M358.526 232.746L356.433 233.254V235.228H358.526V232.746Z",
    fill: "#C74827"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M345.947 238H342.416C341.734 238 341.183 238.552 341.183 239.236V242.521H347.183V239.236C347.181 238.552 346.63 238 345.947 238Z",
    fill: "#FED241"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M357 238H353.469C352.787 238 352.235 238.552 352.235 239.236V242.521H358.236V239.236C358.233 238.552 357.682 238 357 238Z",
    fill: "#FED241"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M365.052 239.429H334.518L337.154 231.802H362.418L365.052 239.429Z",
    fill: "#FDE79F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M293.075 176.399H292.601V182.408H293.075V176.399Z",
    fill: "#EDB58B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M289.003 176.292L289.757 182.121L290.229 182.059L289.473 176.23L289.003 176.292Z",
    fill: "#EDB58B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M295.447 182.059L295.917 182.121L296.676 176.292L296.201 176.23L295.447 182.059Z",
    fill: "#EDB58B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M292.84 138.978C282.079 138.978 275.184 150.428 280.22 159.939L289.039 176.597H296.637L305.456 159.939C310.495 150.428 303.602 138.978 292.84 138.978Z",
    fill: "#EDB58B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M292.839 138.978C285.328 138.978 280.515 150.428 284.031 159.939L290.188 176.597H295.491L301.648 159.939C305.164 150.428 300.351 138.978 292.839 138.978Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M292.839 138.978C290.193 138.978 288.501 150.428 289.737 159.939L291.904 176.597H293.773L295.94 159.939C297.181 150.428 295.486 138.978 292.839 138.978Z",
    fill: "#EDB58B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M294.047 187.049H291.67C291.157 187.049 290.714 186.698 290.609 186.208L289.696 181.944H296.022L295.109 186.208C295.001 186.7 294.56 187.049 294.047 187.049Z",
    fill: "#EDB58B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M295.942 182.29H289.696C289.542 182.29 289.416 182.164 289.416 182.01C289.416 181.859 289.542 181.733 289.696 181.733H295.942C296.096 181.733 296.222 181.859 296.222 182.01C296.222 182.164 296.096 182.29 295.942 182.29Z",
    fill: "#EDB58B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBanner);
export default __webpack_public_path__ + "static/media/heroBanner.76ac2dcaaeec6e47bda4f41ea1dccf07.svg";
export { ForwardRef as ReactComponent };